import React from 'react';
import PropTypes from 'prop-types';
import { Box, Copy, Icon, IconWrapper, Link } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';

import formatDealerAddress from '../../../utils/formatDealerAddress';
import getDirectionsUrl from '../../../utils/getDirectionsUrl';
import themeStyles from './DealerLocation.style';
import { useVariant } from '../../../context/VariantContext';
import variantsConfig from '../variantsConfig';

const DirectionsWrapper = themeStyles.apply(Box, 'DirectionsWrapper');
const Address = themeStyles.apply(Copy, 'Address');
const DirectionsLink = themeStyles.apply(Link, 'DirectionsLink');

const DealerLocation = ({ address, hasBadge }) => {
  const { t } = useTranslation();
  const variant = useVariant();
  const { dealerLocationIconColor } = variantsConfig.getVariantConfig(variant);

  const dealerAddress = formatDealerAddress(address);
  const directionsUrl = getDirectionsUrl(address?.coordinates);

  return (
    <DirectionsWrapper>
      <IconWrapper data-testid="cy-dealer-address-icon">
        <Icon name="mapMarker" />
      </IconWrapper>
      <Box>
        <Address data-testid="cy-dealer-address" hasBadge={hasBadge}>
          {dealerAddress}
        </Address>
        <DirectionsLink
          as="a"
          data-testid="cy-dealer-directions"
          href={directionsUrl}
          styling="primary"
          target="_blank"
          linkColor=""
        >
          {t('Sub-apps.Dealers.directionsButton')}
          <Icon ml="xxs" height="8px" name="arrowRight" iconColor={dealerLocationIconColor} />
        </DirectionsLink>
      </Box>
    </DirectionsWrapper>
  );
};

DealerLocation.defaultProps = {
  address: {},
};

DealerLocation.propTypes = {
  address: PropTypes.shape({
    address: PropTypes.string,
    city: PropTypes.string,
    province: PropTypes.string,
    postalCode: PropTypes.string,
    coordinates: PropTypes.shape({
      latitude: PropTypes.string,
      longitude: PropTypes.string,
    }),
  }),
  hasBadge: PropTypes.bool,
};

export default DealerLocation;
